// extracted by mini-css-extract-plugin
module.exports = {"editme":"VnkXEMxMx5MaPgpMu2YFC","value":"bS-2m7OrFlev0wyS61Lh0","fake":"_3ULvi-VvEnLIbWr5ILTLMb","placeholder":"_1CH0oPOg_hVFy235NY52v5","icon":"_12dVPUgyKBVE6P4Kd_HvW6"};